import React from 'react'

export default function About() {
    return (
        <div className="about">
            <div>
                <h1>About the website</h1>
            </div>
            <div>
                <h3>This website is made using Html5,css3,React bootstrap and Reactjs
                    In this site advanced concepts of React.js like ROUTING,REACT TYPED,REACT TS PARTICLES
                    is used 
                </h3>
            </div>
        </div>
    )
}
